import { render } from "./SecurityPosition.vue?vue&type=template&id=24b69afe&scoped=true"
import script from "./SecurityPosition.vue?vue&type=script&lang=js"
export * from "./SecurityPosition.vue?vue&type=script&lang=js"

import "./SecurityPosition.vue?vue&type=style&index=0&id=24b69afe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b69afe"]])

export default __exports__